export default "__VITE_ASSET__58071758__"